module.exports = __webpack_public_path__ + "static/media/MessagePlus_logo.ef3f1e41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MessagePlus_logo.png
// module id = 105
// module chunks = 1